import React from 'react';
import times from 'lodash/times';
import { TextLoading } from '../../../CommonComponents/OPL/Text/Text.loading';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { ContentWrapper } from '../../ClientGetStartedModal.styles';

export const LanguagePreferenceLoading = () => {
  return (
    <>
      <ContentWrapper>
        <TextLoading width={200} height="h6" mb="16" />

        {times(4).map(key => (
          <Box key={key} display="flex" mb="24">
            <Shimmer width={16} height={16} mr="8" />
            <Shimmer width={150} height={16} />
          </Box>
        ))}
      </ContentWrapper>

      <ModalFooter>
        <Shimmer height={36} width={65} />
      </ModalFooter>
    </>
  );
};
